import React from 'react';
import '../css/CompanyLogos.css';
import p1 from '../images/p1.png';
import p2 from '../images/p2.png';
import p3 from '../images/p3.png';
import p4 from '../images/p4.png';
import p5 from '../images/p5.png';
import p6 from '../images/p6.png';



function CompanyLogos() {
  return (
    <div className="companyLogos container-fluid">
        <div className="row">
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p1} className="img-fluid compLogo" alt=""/>
            </div>
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p2} className="img-fluid compLogo" alt=""/>
            </div>
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p3} className="img-fluid compLogo" alt=""/>
            </div>
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p4} className="img-fluid compLogo" alt=""/>
            </div>
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p5} className="img-fluid compLogo" alt=""/>
            </div>
            <div className="col-lg-2 col-md-4 col-6 m-auto">
                <img src={p6} className="img-fluid compLogo" alt=""/>
            </div>
        </div>
    </div>
  );
}

export default CompanyLogos;
